import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-responsive-modal';
import 'react-responsive-modal/styles.css';
import styled from 'styled-components';

const StyledPSModalBody = styled.div`
  margin: 0 1rem !important;
`;

const PSModal = React.forwardRef(
  ({ children, open, center, onClose, showCloseIcon, classNames, ...props }, ref) => {
    return (
      <Modal
        ref={ref}
        open={open}
        animationDuration={0}
        center={center}
        onClose={onClose}
        classNames={classNames}
        showCloseIcon={showCloseIcon}
        {...props}
      >
        <StyledPSModalBody className="container-children">{children}</StyledPSModalBody>
      </Modal>
    );
  }
);

PSModal.displayName = 'PSModal';

PSModal.defaultProps = {
  open: false,
  center: true,
  classNames: {
    overlay: 'customOverlay',
    modal: 'customModal',
  },
  onClose: () => {},
  showCloseIcon: true,
};

PSModal.propTypes = {
  children: PropTypes.node,
  open: PropTypes.bool,
  center: PropTypes.bool,
  onClose: PropTypes.func,
  classNames: PropTypes.object,
  showCloseIcon: PropTypes.bool,
};

export default PSModal;
